/* eslint-disable react/prop-types */
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import './legends.scss';
import { Grid, Skeleton, Typography } from '@mui/material';
import Storage from 'src/utils/storage/storage';
import { getOpportunityToColorMap } from '../../../home';

export default function Legends() {
  const appDispatch = useAppDispatch();
  const { source: sourceId } = Storage.getSourceId();
  const { isFetchingOpportunityToColorMap, opportunityToColorMap } =
    useAppSelector((state) => state.simulatorHome);

  const legendStyle = (currColor) => ({
    height: '10px',
    width: '10px',
    margin: '4px',
    backgroundColor: currColor
  });

  useEffect(() => {
    appDispatch(getOpportunityToColorMap(sourceId));
  }, []);

  return (
    <Grid container alignItems='center'>
      <Grid item xs='auto'>
        <Typography fontSize='10px' component='div'>
          Legends -{' '}
        </Typography>
      </Grid>
      <Grid ml={1} container item xs='auto' alignItems='center'>
        {opportunityToColorMap.map((opportunity) => (
          <Grid
            item
            xs='auto'
            container
            key={opportunity.pk_id}
            alignItems='center'
            mr={1}
          >
            {isFetchingOpportunityToColorMap ? (
              <Skeleton
                sx={{
                  height: '10px',
                  width: '10px',
                  margin: '4px'
                }}
                variant='rectangular'
              />
            ) : (
              <Grid
                item
                xs='auto'
                sx={{
                  height: '10px',
                  width: '10px',
                  margin: '4px',
                  backgroundColor: opportunity.color
                }}
                style={legendStyle(opportunity.color)}
              >
                &nbsp;
              </Grid>
            )}
            <Grid item xs='auto'>
              {isFetchingOpportunityToColorMap ? (
                <Skeleton variant='rectangular' width={30} height={10} />
              ) : (
                <Typography fontSize='10px' component='div'>
                  {opportunity.label}{' '}
                </Typography>
              )}
            </Grid>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}
